import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {addSection} from '../actions/addSection'
import {
    GALLERY,
    TITLE,
    SUBTITLE,
    PARAGRAPH,
    IMAGE,
    ZOOMABLEIMAGE,
    UNORDEREDLIST, ORDEREDLIST
} from "../../../../components/sectionTypes";

class AddSection extends Component {

    constructor(props) {
        super(props);
        this.state = {
            prompt: 0,
            options: {
                "Seleccione por favor": null,
                "Parrafo": PARAGRAPH,
                "Titulo": TITLE,
                "SubTitulo": SUBTITLE,
                "Galeria": GALLERY,
                "Imagen": IMAGE,
                "Imagen con zoom": ZOOMABLEIMAGE,
                "Lista con bullets": UNORDEREDLIST,
                "Lista enumerada": ORDEREDLIST
            }
        };
    }

    addSection(event) {
        const {value} = event.target;
        const type = this.state.options[value];
        if (type === null) {
            return;
        }

        let section = {};
        section["type"] = type;

        if (PARAGRAPH === type || TITLE === type || SUBTITLE === type) {
            section["content"] = "";
        }

        if (ZOOMABLEIMAGE === type || IMAGE === type) {
            section["url"] = "";
        }

        if (GALLERY === type) {
            section["slides"] = {};
        }

        if (UNORDEREDLIST === type || ORDEREDLIST === type) {
            section["elements"] = {};
            section["prepend"] = "";
            section["append"] = "";
        }

        this.props.add(section);
        this.setState({prompt:0});
    }


    render() {
        return (
            <div className="col-md-12">
                <div className="form-group">
                    <label htmlFor="addSectionSelect">Añadir Sección</label>
                    <select className="form-control" id="addSectionSelect" onChange={this.addSection.bind(this)} value={this.state.prompt}>
                        <Options options={this.state.options}/>
                    </select>
                </div>
            </div>
        );
    }
}

function Options({options}) {
    return Object.keys(options).map(key => <option value={key} key={key}>{key}</option>);
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({add: addSection}, dispatch);
}

export default connect(null, mapDispatchToProps)(AddSection);


// WEBPACK FOOTER //
// ./src/admin/components/editor/containers/AddSection.js